/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonAddIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="18.5" cy="18.5" r="5" />
      <line x1="18.5" y1="16" x2="18.5" y2="21" />
      <line x1="21" y1="18.5" x2="16" y2="18.5" />
      <line x1="12.5" y1="14.5" x2="12.5" y2="11.696" />
      <path d="M7.5,11.696V14.5 l-5.009,1.789C1.297,16.716,0.5,17.847,0.5,19.114V21.5h11" />
      <ellipse cx="10" cy="6.5" rx="5" ry="6" />
      <path d="M14.953,5.953 C14.785,5.974,14.669,5.967,14.5,6c-1.703,0.328-2.797-0.289-3.734-1.93C10.203,5.148,8.444,6,7,6 C6.289,6,5.677,5.854,5.064,5.534" />
    </g>
  </svg>
);

export default PersonAddIcon;
